import React from 'react';
import { useDispatch } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { isUndefined, isNull } from 'lodash';

import { Loading, LoadingError } from '@components/Base';

import { healthQuoteUpdate, HealthQuoteUpdatePayload } from '../action';
import { useHealthQuoteFetch } from '../hook';
import HealthQuoteBuyForm, { FormValues } from '../HealthQuoteBuyForm';
import { RightCol } from '../right-col';
import { useInitialValues } from './hook';

const HealthQuoteBuyEditPage = () => {
  const dispatch = useDispatch();
  const healthQuote = useHealthQuoteFetch();
  const initialValues = useInitialValues();

  if (isUndefined(healthQuote)) return <Loading />;
  if (isNull(healthQuote)) return <LoadingError />;
  if (!initialValues) return null;

  const {
    orderNumber,
    healthPlanName,
    healthPlanQuestions,
    occupationDeclarationDescription } = healthQuote;

  const handleSubmit = (values: FormValues) => {
    const payload: HealthQuoteUpdatePayload = { orderNumber, ...values };
    dispatch(healthQuoteUpdate(payload));
  };

  return (
    <Container className="my-3">
      <Row className="gy-5">
        <Col lg={8}>
          <HealthQuoteBuyForm
            initialValues={initialValues}
            onSubmit={handleSubmit}
            questions={healthPlanQuestions}
            description={occupationDeclarationDescription} />
        </Col>
        <RightCol {...healthQuote} planName={healthPlanName} />
      </Row>
    </Container>
  );
};

export { HealthQuoteBuyEditPage };
